import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#546E7A',
        secondary: '#607D8B',
        accent: '#4DB6AC',
        general: '#9E9E9E',
        physique: 'B71C1C',
        finesse: '#388E3C',
        mind: '#4FC3F7',
        spirit: '#FFAB00'
      }
    }
  },
  icons: {
    //iconfont: 'mdi',
  }
});
